import React from "react";
import { useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import HelmetWrapper from "../../HelmetWrapper";
import LMSStructure from "../../components/lead-management/lms-v2/LMSStructure";
import { selectAuth } from "../../components/auth/auth.selector";
import "../../styles/lead-mangement/lms.css";

const LMSBeta = () => {
  const authData = useSelector(selectAuth);
  const userInfoData = authData?.user || {};

  return (
    <HelmetWrapper title="WTF: Lead Management System">
      <Container className="bg-cloud-k px-50px" fluid>
        <LMSStructure userInfoData={userInfoData} />
      </Container>
    </HelmetWrapper>
  );
};

export default LMSBeta;
